export default __webpack_public_path__ + "static/media/like.e0c62494.png";